import axios from 'axios';
import { IOrder } from '../types';

const baseUrl: string = process.env.REACT_APP_CLOUD_API_URL || "http://localhost:8080";

export interface PublicAuthParams {
    audience?: string;
    client_id?: string;
    client_secret?: string;
    grant_type?: string;
}

interface AuthResponse {
    access_token: string;
    scope: string;
    token_type: string;
    expires_in: number;
}

export interface PublicProduct {
    id: string;
    workspaceId: string;
    descriptionShort: string;
    description: string;
    isPublic: boolean;
    imgUrls: string[];
    seatsEnabled?: boolean;
    seatCount?: number;
    weight: number;
    length: number;
    height: number;
    width: number;
    price: number;
    productType: string;
    pricing?: {
        priceModel: string[];
        pricePerCargoUnit?: number;
        pricePerDistanceUnit?: number;
        pricePerTimeUnit?: number;
        timePeriodInMinutes?: number;
        pricePerVolumeUnit?: number;
        pricePerSeat?: number;
        pricePerWeightUnit?: number;
        vat?: number;
        pricesIncludeVat?: boolean;
    };
    createdAt?: string;
}

interface ProductsResponse {
    data: PublicProduct[];
}

export const authenticatePublicAccess = async (authParams: PublicAuthParams): Promise<AuthResponse> => {
    if (!authParams.audience || !authParams.client_id || !authParams.client_secret) {
        throw new Error('Missing required authentication parameters');
    }

    try {
        const response = await axios.post(
            `${baseUrl}/api/auth/`,
            {
                audience: authParams.audience,
                client_id: authParams.client_id,
                client_secret: authParams.client_secret,
                grant_type: 'client_credentials'
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error authenticating:', error);
        throw error;
    }
};

export const submitPublicOrder = async (order: IOrder, authParams: PublicAuthParams, accessToken: string) => {
    if (!authParams.audience || !accessToken) {
        throw new Error('Missing required authentication parameters');
    }

    try {
        const response = await axios.post(
            `${baseUrl}/api/orders/draft`,
            order,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    "x-workspace-id": authParams.audience
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error submitting public order:', error);
        throw error;
    }
};

export const fetchPublicProducts = async (workspaceId: string, accessToken: string): Promise<PublicProduct[]> => {
    try {
        const response = await axios.get<ProductsResponse>(
            `${baseUrl}/api/products/public`,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'X-Workspace-Id': workspaceId
                }
            }
        );
        console.log(response.data);
        return response.data.data || [];
    } catch (error) {
        console.error('Error fetching public products:', error);
        throw error;
    }
}; 